import React, { useEffect, useRef, useState } from "react";

// import camTilt from "../assets/images/cam_rotate.png";

import { Button } from "react-bootstrap";
import { camHandler } from "../../FaceMesh/camHandler";
// import { TOASTS } from "../Functions/Ui_specific/messagesAndDefaults";

const Capture = ({ CaptureImage, classSet, setCaptureImage, handleClose, type, camList }) => {
    const [stream, setStream] = useState(null);
    const [isLivenessCheckPassed, setIsLivenessCheckPassed] = useState(false);
    const [imageData, setImageData] = useState(CaptureImage);


    useEffect(() => {
        setImageData(null)
        return () => {
            setImageData(null)
        }
    }, [])

    let camTilt;

    const handleReCapture = () => {
        setImageData('')
    }

    const formatData = (data, type, name) => {
        return { type: type, data: data, name: name };
    }
    const handleCapture = () => {
        if (imageData) {
            setCaptureImage((pre) => ({ ...pre, primaryFile: imageData, }))
            handleClose()
            setImageData(null)

        }
        else {
            const video = document.querySelector('#camera');
            const canvas = document.querySelector('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const context = canvas.getContext('2d');
            context.drawImage(video, 0, 0);

            const dataURL = canvas.toDataURL('image/png');
            setImageData(dataURL);

            // //console.log(imageData)
        }

    }
    const handlecamFlip = async () => {
        document.getElementById("camera").pause();
        document.getElementById("camera").srcObject = null;

        await camHandler.flipCam()

        document.getElementById("camera").srcObject = camHandler.videoStrem;
        //  //console.log("testam", document.getElementById("camera").srcObject)


        document.getElementById("camera").addEventListener(
            "canplay",
            async () => {



                document.getElementById("camera").play();
            },
            { once: true }
        )
    }

    const handleCaptureClose = () => {

        handleClose()
        setImageData(null)
    }

    return (
        <>

            <div className="bg_gray rounded mb-2">
                <div className={`${!imageData && "scanning_box"} ${type && "square"} position-relative overflow-hidden rounded-3`}>
                    {<div
                        className="bg_master2 end-0 font_14 lh-1 mt-2 me-2 zi_1 position-absolute px-3 py-2 br_5 text-white top-0 cursor-pointer hover"
                        onClick={handleCaptureClose}
                    >
                        <span className="py-1 d-block">
                            <i className="fas fa-times"></i>
                        </span>
                    </div>}
                    <div id='dir' className="arrow_set d-none">
                        <i className="fas fa-chevron-down arrow_anim"></i>
                    </div>
                    {(camList?.length > 1 && type) && <div className="bottom-0 end-0 p-2 position-absolute zi_1" >
                        <img src={camTilt} width="25" className="cursor-pointer hover" onClick={handlecamFlip} />
                    </div>}


                    <video id="camera" className={`fd_streaming_video w-100 ${imageData && "d-none"}`} playsInline autoPlay />
                    <canvas id="canvas" className={`fd_streaming_video w-100 ${!imageData && "d-none"}`}></canvas>
                    <div className={`scannerline ${imageData && "d-none"} ${type && "d-none"}`}>
                    </div>

                </div>
            </div>

            <div>
                {<div className="bg_master p-2 rounded text-white font_12 d-none  d-flex justify-content-center align-items-center bottom_instruction_bx">
                    <p className="mb-0 text-center" id="instruct">
                        {/* {type?"Please Capture Signature":TOASTS.STEADY_FACE} */}

                    </p>

                </div>}
                {!type && <div className="mt-2 text-center">
                    <button className=" btn btn-t3  " onClick={handleReCapture}>Re Capture</button>
                    <Button variant="master" className="ms-3 btn-master2" onClick={handleCapture}>
                        {imageData ? "Proceed" : "Capture"}
                    </Button>
                </div>}
            </div>

        </>
    );
};

export default Capture;
